import React from "react";
import {
  PROJECT_TYPE_LABELS, BUDGET_LABELS, TIMELINE_LABELS,
  STATUS_LABELS, statusPillClass,
} from "@/lib/api";

export function StatusPill({ status }) {
  return (
    <span className={statusPillClass(status)} data-testid={`status-pill-${status}`}>
      {STATUS_LABELS[status] || status}
    </span>
  );
}

export function ProjectMeta({ project }) {
  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-sm">
      <div>
        <div className="overline">Type</div>
        <div className="font-medium mt-1">{PROJECT_TYPE_LABELS[project.project_type]}</div>
      </div>
      <div>
        <div className="overline">Budget</div>
        <div className="font-medium mt-1">{BUDGET_LABELS[project.budget_range]}</div>
      </div>
      <div>
        <div className="overline">Timeline</div>
        <div className="font-medium mt-1">{TIMELINE_LABELS[project.timeline]}</div>
      </div>
      <div>
        <div className="overline">Status</div>
        <div className="mt-1"><StatusPill status={project.status} /></div>
      </div>
    </div>
  );
}

export function PageHeader({ overline, title, description, actions }) {
  return (
    <div className="flex flex-col md:flex-row md:items-end justify-between gap-4 mb-8">
      <div>
        {overline && <div className="overline mb-2">{overline}</div>}
        <h1 className="font-display text-4xl md:text-5xl font-extrabold leading-tight">{title}</h1>
        {description && <p className="text-[var(--bq-text-muted)] mt-2 max-w-2xl">{description}</p>}
      </div>
      {actions && <div className="flex gap-2 flex-wrap">{actions}</div>}
    </div>
  );
}

export function KPI({ label, value, hint, testId }) {
  return (
    <div className="bq-card p-5" data-testid={testId}>
      <div className="overline">{label}</div>
      <div className="font-display text-3xl font-bold mt-2">{value}</div>
      {hint && <div className="text-xs text-[var(--bq-text-muted)] mt-1">{hint}</div>}
    </div>
  );
}
